module.exports = "../fonts/hotel_deposit_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_deposit_icon.svg
// module id = 437
// module chunks = 0